import { useEffect } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import BusinessHero from "./components/BusinessHero";
import BusinessServices from "./components/BusinessServices";
import BusinessProcess from "./components/BusinessProcess";
import BusinessContactForm from "./components/BusinessContactForm";

export default function BusinessPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || "";

    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "工商合作｜娛樂紅歡密 Rappy me",
      "description": "娛樂紅歡密提供多元工商合作服務，包含直播、展場活動、SG人員、舞團表演、活動策劃、網紅業配代言、形象廣告、攝影紀錄等，歡迎品牌洽談合作。",
      "url": `${siteUrl}/business`,
      "inLanguage": "zh-TW",
      "isPartOf": {
        "@type": "WebSite",
        "name": "娛樂紅歡密 Rappy me",
        "url": siteUrl,
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首頁",
            "item": siteUrl,
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "工商合作",
            "item": `${siteUrl}/business`,
          },
        ],
      },
      "mainEntity": {
        "@type": "Service",
        "name": "工商合作服務",
        "provider": {
          "@type": "Organization",
          "name": "娛樂紅歡密 Rappy me",
          "url": siteUrl,
          "sameAs": [
            "https://www.instagram.com/rappy.meme/",
            "https://www.facebook.com/Red.shrimp.close/",
          ],
        },
        "serviceType": ["直播合作", "展場活動", "SG人員", "舞團表演", "活動策劃", "網紅業配", "形象廣告", "攝影紀錄"],
        "areaServed": {
          "@type": "Place",
          "name": "台灣",
        },
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-business";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    document.title = "工商合作｜娛樂紅歡密 Rappy me｜台中活動策劃平台";

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || "";
    if (metaDesc) {
      metaDesc.setAttribute("content", "娛樂紅歡密提供多元工商合作服務，包含直播、展場活動、SG人員、舞團表演、活動策劃、網紅業配代言、形象廣告、攝影紀錄等，歡迎台灣品牌洽談合作。");
    }

    return () => {
      const el = document.getElementById("schema-business");
      if (el) el.remove();
      document.title = "娛樂紅歡密 Rappy me｜台中台灣露營聯誼活動策劃平台｜讀書會親子營";
      if (metaDesc) {
        metaDesc.setAttribute("content", prevDesc);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <BusinessHero />
      <BusinessServices />
      <BusinessProcess />
      <BusinessContactForm />
      <Footer />
    </div>
  );
}
